import { apiClient } from "./client";
import type {
  AvailableColumn,
  AvailableColumnsResponse,
} from "./types";

/**
 * Lists the columns this project's lists can render. Each column carries
 * its render type, default visibility, lock flag, and (for metadata-backed
 * columns) the metadata key to read from Company.metadata.
 *
 * The set is project_type-driven, so the response depends on which
 * project the user is currently in.
 */
export async function getAvailableColumns(
  slug: string,
): Promise<AvailableColumn[]> {
  const res = await apiClient.get<AvailableColumnsResponse>(
    `/projects/${slug}/columns`,
  );
  return res.data.columns;
}
